import {
  emailSchema,
  getDateRangeFromAge,
  getDateSchema,
  getNameSchema,
} from '@breezeventures/web-ph-validators/zod-schemas';
import { z } from 'zod';

export const basicInfoSchema = z.object({
  firstName: getNameSchema({
    required: true,
    requiredMessage: 'First name is required',
  }),
  middleName: getNameSchema({
    required: true,
    requiredMessage: 'Middle name is required',
  }),
  lastName: getNameSchema({
    required: true,
    requiredMessage: 'Last name is required',
  }),
  dateOfBirth: getDateSchema({
    required: true,
    requiredMessage: 'Date of birth is required',
    ...getDateRangeFromAge({ minAge: 7, maxAge: 90 }),
    rangeMessage: 'Enter a valid date of birth',
  }),
  email: emailSchema,
  pointOfContact: z.string().trim().optional(),
});

export type BasicInfoFormValues = z.infer<typeof basicInfoSchema>;
